import type {FC} from 'react';

import {observer} from 'mobx-react';

import type {Props} from './types';

import {LoadingSpinner} from '../../../../uikit/LoadingSpinner';
import * as S from './styles';

export const ModalLoading: FC<Props> = observer(({isLoading}) => {
  return isLoading ? (
    <S.Container>
      <LoadingSpinner size={50} />
    </S.Container>
  ) : null;
});
